import { Paper, Tab, Tabs, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import { useEffect, useState } from "react";
import ChangePassword from "../../components/profile/ChangePassword";
import UpdateProfile from "../../components/profile/UpdateProfile";
import EmailIntegrations from "../../components/profile/EmailIntegrations";
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import EmailIcon from '@mui/icons-material/Email';

function getQueryParam(key) {
  const params = new URLSearchParams(window.location.search);
  return params.get(key);
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 4 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const ManageProfilePage = () => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    const tab = getQueryParam("tab");
    if (tab === "email") {
      setValue(2); // index of "Email Integrations"
    }
  }, []);

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Container maxWidth={false} sx={{ mt: { xs: 10, sm: 2 }, mb: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: '#111827', mb: 1 }}>
          Manage Profile
        </Typography>
        <Typography variant="body2" sx={{ color: '#6B7280' }}>
          Update your personal information, security settings, and integrations.
        </Typography>
      </Box>

      <Paper 
        elevation={0} 
        sx={{ 
          p: { xs: 2, md: 4 }, 
          borderRadius: '16px', 
          border: '1px solid #E5E7EB',
          minHeight: '600px'
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: '#F3F4F6' }}>
          <Tabs 
            value={value} 
            onChange={handleChange} 
            aria-label="profile tabs"
            sx={{
              "& .MuiTab-root": {
                textTransform: 'none',
                minHeight: 48,
                fontWeight: 600,
                fontSize: '14px',
                color: '#6B7280',
                '&.Mui-selected': {
                  color: '#2259c9',
                },
              }
            }}
          >
            <Tab 
              icon={<PersonIcon sx={{ fontSize: 20 }} />} 
              iconPosition="start" 
              label="Profile Details" 
              {...a11yProps(0)} 
            />
            <Tab 
              icon={<LockIcon sx={{ fontSize: 20 }} />} 
              iconPosition="start" 
              label="Security" 
              {...a11yProps(1)} 
            />
            <Tab 
              icon={<EmailIcon sx={{ fontSize: 20 }} />} 
              iconPosition="start" 
              label="Integrations" 
              {...a11yProps(2)} 
            />
          </Tabs>
        </Box>

        <TabPanel value={value} index={0}>
          <UpdateProfile />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ChangePassword />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <EmailIntegrations />
        </TabPanel>
      </Paper>
    </Container>
  );
};

export default ManageProfilePage;
